import { addPostRegistrationColor, getColors, removeColor, } from '@wix/ambassador-identity-users-v1-user/http';
import { calculateUserFlavor, USER_FLAVORS, } from '../../api/calculateUserFlavor';
import { useEffect, useState } from 'react';
export const useUserFlavor = ({ httpClient, errorMonitor, panoramaClient, }) => {
    const [userFlavor, setUserFlavorValue] = useState(USER_FLAVORS.NO_CODE);
    const setUserFlavor = async (flavor) => {
        if (userFlavor !== flavor) {
            if (flavor === USER_FLAVORS.NO_CODE) {
                try {
                    await httpClient.request(removeColor({ color: USER_FLAVORS.DEVELOPER }));
                }
                catch (error) {
                    panoramaClient?.errorMonitor().reportError(error);
                    errorMonitor?.captureException(error);
                }
            }
            try {
                await httpClient.request(addPostRegistrationColor({ color: flavor }));
                setUserFlavorValue(flavor);
            }
            catch (error) {
                panoramaClient?.errorMonitor().reportError(error);
                errorMonitor?.captureException(error);
            }
        }
    };
    const getUserFlavor = async () => {
        try {
            const res = await httpClient.request(getColors({}));
            setUserFlavorValue(calculateUserFlavor(res.data.colors));
        }
        catch (error) {
            panoramaClient?.errorMonitor().reportError(error);
            errorMonitor?.captureException(error);
        }
    };
    useEffect(() => {
        void getUserFlavor();
    }, []);
    return { userFlavor, setUserFlavor };
};
//# sourceMappingURL=useUserFlavor.js.map